import { Injectable } from "@angular/core";
import { CerrixInputValidationError } from "./models/cerrix-input-validation-error.interface";
import { CerrixInputValidation } from "./models/cerrix-input-validation.interface";
import { CerrixInputValidationErrorsDirective } from "./cerrix-input-validation-errors.directive";

@Injectable()
export class CerrixInputValidationRegistryService {
    private readonly _errorDirectives: { [index: string]: CerrixInputValidationErrorsDirective } =
        {};
    private readonly _validators: CerrixInputValidation[] = [];

    registerInputValidation(
        errorsDirective: CerrixInputValidationErrorsDirective,
        cerrixInputValidation: CerrixInputValidation,
    ) {
        this._errorDirectives[errorsDirective.fieldName()] = errorsDirective;
        this._validators.push(cerrixInputValidation);
    }

    runValidators() {
        this._validators.forEach((v) => v.validate());
    }

    getErrorsFor(fieldId: string): CerrixInputValidationError[] {
        return this._errorDirectives[fieldId]?.errors() ?? [];
    }

    allErrors(): CerrixInputValidationError[] {
        const combined: CerrixInputValidationError[] = [];
        for (const key in this._errorDirectives) {
            const errorsDirective = this._errorDirectives[key];
            combined.push(...errorsDirective.errors());
        }
        return combined;
    }

    allMessages(): string[] {
        return this.allErrors().map((e) => e.message);
    }

    hasAnyErrors() {
        for (const key in this._errorDirectives) {
            const errorsDirective = this._errorDirectives[key];
            if (errorsDirective.errors().length > 0) {
                return true;
            }
        }
        return false;
    }

    resetErrors() {
        for (const key in this._errorDirectives) {
            const errorsDirective = this._errorDirectives[key];
            errorsDirective.reset();
        }
    }
}
